import { AlertColor } from "@mui/material";

export interface HubMessageNotification {
	type: HubMessageNotificationType;
	message: string;
	isReceivedMessage: boolean | null;
	requestId: string | null;
	requestMessageType: string | null;
	deviceNames: string[] | null;
	dateCreated: string | null;
}

export enum HubMessageNotificationType {
	Success = 0,
	Info = 1,
	Warning = 2,
	Error = 3,
}

export const getAlertColor = (type: HubMessageNotificationType): AlertColor => {
	switch (type) {
		case HubMessageNotificationType.Success:
			return "success";
		case HubMessageNotificationType.Error:
			return "error";
		case HubMessageNotificationType.Warning:
			return "warning";
		case HubMessageNotificationType.Info:
			return "info";
		default:
			return "info";
	}
};
